import TiktokAds from "../../../../contents/docs/cdp/sources/_snippets/source-tiktok-ads.mdx";
import * as React from 'react';
export default {
  TiktokAds,
  React
};